import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import Message from "./Message";
import {Input} from "antd";
import './ConversationCard.css'
import MessageEvent from "./MessageEvent";
import BoxFooter from "../BoxFooter";
import Card from "../../common/Card";

const {TextArea} = Input;

class ConversationCard extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    const {conversation} = this.props;
    if (!conversation || !conversation.messages || !conversation.messages.length){
      return;
    }
    const messageId = conversation.messages[conversation.messages.length-1].id;
    if (!this.lastMessageId || this.lastMessageId !== messageId){
      this.scrollToBottom();
      this.lastMessageId = messageId;
    }
  }

  onMessageChange = (e) => {
    this.setState({
      message: e.target.value
    });
  };

  scrollToBottom = () => {
    if (this.scrollDiv){
      this.scrollDiv.scrollTop = this.scrollDiv.scrollHeight;
    }
  };

  onSendMessageClick = (event) => {
    event.preventDefault();
    const {vin} = this.props;
    const {message} = this.state;
    this.props.dispatchSendMessage({vin, body:{message}})
    this.setState({message: null});
  };
  onMarkAsReadClick = (event) => {
    event.preventDefault();
    const {vin} = this.props;
    this.props.dispatchMarkAsRead({vin})
  };

  render() {
    const {intl: {formatMessage}, conversation, ticket, interventionId, canWrite} = this.props;
    if (!conversation){
      return null;
    }

    const hasMessages = conversation && conversation.messages && conversation.messages.length > 0;

    const hasUnreadMessage = conversation.lastMessageHandled === false;

    return (

      <Card
        title={formatMessage({id:'appointment.detail.conversation.title'})}
        onAlert={hasUnreadMessage}
        footer={canWrite &&
        <BoxFooter>
          <form span={hasUnreadMessage ? 12 : 18} action="#" className="appointment-messages-answer">
            <TextArea className={"appointment-messages-answer__field"} ref={(input) => { this.messageTextArea = input; }}
                      placeholder={formatMessage({id:'placeholder.your-answer'})}           autosize={{ minRows: 1, maxRows: 10 }}
                      onChange={this.onMessageChange} value={this.state.message}/>

          </form>
          {hasUnreadMessage &&
          <button style={{marginRight:5}} onClick={ this.onMarkAsReadClick} className="btn btn-sm btn-primary">{formatMessage({id:'button.mark-as-read'})}</button>
          }
          <button onClick={ this.onSendMessageClick } className="btn btn-sm btn-primary">{formatMessage({id:'button.send'})}</button>
        </BoxFooter>

        }
        >
        <div ref={(el) => { this.scrollDiv = el; }}>
          {hasMessages && <ol className="messages">
            {conversation.messages.map((message, index)=>{return <Message key={index} message={message}/>})}
          </ol>}
          {!hasMessages && <span>{formatMessage({id:'empty.conversation'})}</span>}
        </div>

        {conversation && <MessageEvent interventionId={interventionId} ticket={ticket} />}
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  vin: state.fetchIntervention.intervention.vehicle.vin,
  loading: state.fetchIntervention.loading,
  conversation: state.fetchIntervention.intervention && state.fetchIntervention.intervention.conversation,
  interventionId: state.fetchIntervention.intervention && state.fetchIntervention.intervention.id,
  ticket: state.fetchIntervention.intervention && state.fetchIntervention.intervention.ticket,
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchConversation: (params) => dispatch({type: 'FETCH.CONVERSATION.REQUEST', ...params}),
  dispatchSendMessage: (params) => dispatch({type: 'SAVE.CONVERSATION_MESSAGE.REQUEST', ...params}),
  dispatchMarkAsRead: (params) => dispatch({type: 'SAVE.CONVERSATION_MARK_AS_READ.REQUEST', ...params}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)(injectIntl(ConversationCard))
